module.exports = __webpack_public_path__ + "img/224-e1c27d.png";